import { PLAY_REFRESH_DATA ,
  PLAY_SET_FIELD_VALUE,
  PLAY_UPDATE_CHART_NAME,
  PLAY_SET_DATA,
  PLAY_SET_CHART_DATA_ERROR,
  PLAY_SET_CHART_DATA_LOADING,
  PLAY_SET_CHART_DATA_SUCCESS,
  PLAY_SHOW_ERRORS,
  PLAY_SAVE_PLAY_DATA_ERROR,
  DISABLE_SAVING,
  PLAY_SAVE_PLAY_DATA_SUCCESS,
  PLAY_SAVE_PLAY_DATA_LOADING,
} from '../actions/constants';
export default function (state: any = { revisionId: Date.now() }, action) {
  switch (action.type) {
    case PLAY_SET_FIELD_VALUE: {
      const controls = { ...state.controls };
      const control = { ...controls[action.controlName] };
      control.value = action.value;
      control.validationErrors = action.validationErrors;
      controls[action.controlName] = control;
      const changes: any = {
        controls,
      };
      if (control.renderTrigger) {
        changes.triggerRender = true;
      }
      if ((action.controlName === 'visualisation_type')
        || (action.controlName === 'exception_card_type')) {
        changes.chartData = null;
        changes.error = null;
      }
      return {
        ...state,
        ...changes,
      };
    }

    case PLAY_UPDATE_CHART_NAME: {
      return {
        ...state,
        name: action.name,
      };
    }

    case DISABLE_SAVING: {
      return {
        ...state,
        disableSaving: action.data,
      };
    }

    case PLAY_SHOW_ERRORS: {
      return {
        ...state,
        showError: action.showError,
      };
    }

    case PLAY_SAVE_PLAY_DATA_LOADING: {
      return {
        ...state,
        disableSaving: true,
      };
    }

    case PLAY_SAVE_PLAY_DATA_SUCCESS: {

      return {
        ...state,
        ...action.data,
        disableSaving: false,
      };
    }

    case PLAY_SAVE_PLAY_DATA_ERROR: {
      return {
        ...state,
        disableSaving: false,
      };
    }

    case PLAY_SET_CHART_DATA_LOADING: {
      return {
        ...state,
        isChartLoading: true,
      };
    }

    case PLAY_SET_CHART_DATA_ERROR: {
      return {
        ...state,
        error: action.error,
        isChartLoading: false,
      };
    }

    case PLAY_SET_CHART_DATA_SUCCESS: {
      return {
        ...state,
        chartData: action.chartData,
        isChartLoading: false,
        error: null,
      };
    }

    case PLAY_SET_DATA: {
      return {
        ...state,
        ...action.data,
      };
    }

    case PLAY_REFRESH_DATA: {
      return {
        ...state,
        revisionId: Date.now(),
      };
    }

    default: return state;
  }
}
